/** Superficie pública de shared/format. */
export { formatMoney, formatMoneyCompact } from './moneyFormat';
export { plural } from './plural';
export {
  normalizeSearchText,
  matchesSearchText,
  matchesSearchAny,
  accentQueryVariants,
  buildAccentInsensitiveSqlExpression,
  buildAccentInsensitiveLikeClause,
} from './searchText';
